export default __webpack_public_path__ + "static/media/5bcfcfcd0838ba24.cdff49e9f5af3a68dc9f09c8f2601c0e.svg";